import React, {useRef} from 'react'
import PropTypes from 'prop-types'

//Chakra
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

// Service
import { logOut } from 'service/user.service';

const LogOutButton = props => {

  // VARIABLES ===============================================================
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);

  return (
    <>
      <Button
        variant="brand"
        fontSize="17px"
        w="100%"
        maxW="350px"
        h="45"
        mb="10px"
        mt="10px"
        mx={"2"}
        // textTransform={"uppercase"}
        fontWeight={"extrabold"}
        backgroundColor="darkred"
        onClick={onOpen}
      >
        Log Out
      </Button>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Signing Out from Admin Dashboard...
            </AlertDialogHeader>

            <AlertDialogBody>
              Proceed to log out?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => {
                  logOut();
                  console.log("Logged Out from admin");
                  window.location.reload();
                  onClose();
                }}
                ml={3}
              >
                Log Out
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

LogOutButton.propTypes = {}

export default LogOutButton